import { UPDATECUSTOMER_FAIL, UPDATECUSTOMER_SUCCESS } from '../actionTypes';

const initialState = {
	user: null
};

const updateCustomerReducer = (state = initialState, action) => {
	switch (action.type) {
		case UPDATECUSTOMER_SUCCESS:
			return {
				...state,
				isLoggedIn: true,
				user: action.payload.user,
			};
		case UPDATECUSTOMER_FAIL:
			return {
				...state,
				isLoggedIn: false,
				user: null,
			};
		default:
			break;
	}

	return state;
};

export default updateCustomerReducer;
